import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline'
import Dots from 'app/components/Dots'
import { useInfiniteScroll } from 'app/hooks/useInfiniteScroll'
import useSortableData from 'app/hooks/useSortableData'
import { useAppDispatch, useAppSelector } from 'app/state/hooks'
import React, { FC, useCallback, useState } from 'react'
import TokenItem from 'app/features/token/TokenItem'
import Staking from 'app/features/bar/Staking'
import { OnsenModalView } from 'app/features/onsen/enum'
import { selectOnsen, setOnsenModalOpen, setOnsenModalState, setOnsenModalView } from 'app/features/onsen/onsenSlice'
import NextLink from 'next/link'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import {
  Box,
  Button,
  useDisclosure,
  Image,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Flex,
} from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'
import TokenDetail from './analytics/TokenDetail'
import { XSUSHI } from 'app/config/tokens'
import { SELF_ADDRESS, ChainId } from 'sdk'
import { useBar } from 'app/services/graph/hooks/bar'
import { useFactory, useNativePrice, useCustomDayBlock, useTokens } from 'app/services/graph/hooks'

enum ModalType {
  DETAIL,
  STAKE,
}
const SortIcon: FC<{ id?: string; direction?: 'ascending' | 'descending'; active: boolean }> = ({
  id,
  active,
  direction,
}) => {
  if (!id || !direction || !active) return <></>
  if (direction === 'ascending') return <ChevronUpIcon width={12} height={12} />
  if (direction === 'descending') return <ChevronDownIcon width={12} height={12} />
  return <></>
}

// @ts-ignore TYPE NEEDS FIXING
const TokenList = ({ tokens, term }) => {
  const { isOpen: isStakMdlOpen, onOpen: onStakMdlOpen, onClose: onStakMdlClose } = useDisclosure()
  const { isOpen: isAnltcsovOpen, onOpen: onAnltcsovOpen, onClose: onAnltcsovClose } = useDisclosure()
  const { items, requestSort, sortConfig } = useSortableData(tokens, { key: 'token.name', direction: 'descending' })
  const [numDisplayed, setNumDisplayed] = useInfiniteScroll(items)
  const [selectedItem, setSelectedItem] = useState<any>()
  const [type, setType] = useState<any>()
  const dispatch = useAppDispatch()
  const { open, view } = useAppSelector(selectOnsen)

  const handleDismiss = useCallback(() => {
    setType(undefined)
    setSelectedItem(undefined)
    dispatch(setOnsenModalView(undefined))
  }, [dispatch])
  
  const { i18n } = useLingui()
  const block5d = useCustomDayBlock({ chainId: ChainId.AVALANCHE, dayTotal: 5 })
  const exchange = useFactory({ chainId: ChainId.AVALANCHE })

  const exchange5d = useFactory({
    chainId: ChainId.AVALANCHE,
    variables: {
      block: block5d,
    },
    shouldFetch: !!block5d,
  })

  const ethPrice = useNativePrice({ chainId: ChainId.AVALANCHE })

  const xSushi = useTokens({
    chainId: ChainId.AVALANCHE,
    variables: { where: { id: XSUSHI.address.toLowerCase() } },
  })?.[0]

  const sushi = useTokens({
    chainId: ChainId.AVALANCHE,
    variables: { where: { id: SELF_ADDRESS[ChainId.AVALANCHE].toLowerCase() } },
  })?.[0]

  const bar = useBar()
  const xSushiPrice = sushi?.derivedETH * ethPrice * bar?.ratio
  // const APY1d = aprToApy(
  //   (((exchange?.volumeUSD - exchange1d?.volumeUSD) * 0.0005 * 365.25) / (bar?.totalSupply * xSushiPrice)) * 100 ?? 0
  // )
  const bar1d = useBar();
  const bar5d = useBar({variables: { block: block5d }})
  const apy5d = (bar1d?.ratio / bar5d?.ratio - 1) * 30  * 12 * 100 / 5

  return items ? (
    <>
      <TableContainer className="first_line_tblprnt_as">
        <Table variant="simple">
          <Thead className="first_line_tbl">
            <Tr className="">
              <Th>
                <b>#</b>
              </Th>
              <Th className='sort' onClick={() => requestSort('token.name')}>
                <Flex>
                  Token
                  <SortIcon
                    id={sortConfig.key}
                    direction={sortConfig.direction}
                    active={sortConfig.key === 'token.name'}
                  />
                </Flex>
              </Th>
              <Th className='sort' onClick={() => requestSort('token.strategy.apy')}>
                Est. APY
                <SortIcon
                  id={sortConfig.key}
                  direction={sortConfig.direction}
                  active={sortConfig.key === 'token.strategy.apy'}
                />
              </Th>
              <Th>Min. Locked Amount</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody className="last_three_tbl">
            {/* <Tr className='click_btn_as'>
              <Td>
                <Box className='for_line_tble'>
                  <Button className='click_btn_as box_shadov_none_btn'>
                    <Image src='./img/slow_bg_swap.svg' alt='' className='hdr_btn_had hdr_btn_hadv2' />
                  </Button>
                </Box>
              </Td>
              <Td>
                <Button className='click_btn_as box_shadov_none_btn'>
                  OVX
                </Button>
              </Td>
              <Td className='seven_32'>
                - %
              </Td>
              <Td>
                0.1 OVX
              </Td>
              <Td>
                <Button className='stke_tbl_btn' onClick={onStakMdlOpen}>
                  Stake
                </Button>
              </Td>
            </Tr> */}
            {items.slice(0, numDisplayed).map((token, index) => {
              const onlySelfToken = true
              if (!onlySelfToken || token.token.id == SELF_ADDRESS[ChainId.AVALANCHE].toLowerCase()) {
                return (
                  <TokenItem
                    index={index}
                    token={token}
                    key={index}
                    apr={`${apy5d ? apy5d.toFixed(2) + '%' : i18n._(t`Loading...`)}`}
                    // apr={`${APY1d ? APY1d.toFixed(2) + '%' : i18n._(t`Loading...`)}`}
                    onClickDetail={() => {
                      if (!onlySelfToken || token.token.id == SELF_ADDRESS[ChainId.AVALANCHE].toLowerCase()) {
                        setType(ModalType.DETAIL)
                        setSelectedItem(token)
                        dispatch(
                          setOnsenModalState({
                            view: OnsenModalView.Position,
                            open: true,
                          })
                        )
                      }
                    }}
                    onClickStake={() => {
                      if (!onlySelfToken || token.token.id == SELF_ADDRESS[ChainId.AVALANCHE].toLowerCase()) {
                        setType(ModalType.STAKE)
                        setSelectedItem(token)
                        dispatch(
                          setOnsenModalState({
                            view: OnsenModalView.Position,
                            open: true,
                          })
                        )
                      }
                    }}
                  />
                )
              }
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <Box className="viev_all_btn_prnt">
        <NextLink href="/staking" passHref>
          <Button className="viev_all_btn box_shadov_none_btn">
            View All
            <Image src="/img/viev_arrow_ic.svg" alt="" />
          </Button>
        </NextLink>
      </Box>
      <Modal isOpen={isStakMdlOpen} onClose={onStakMdlClose}>
        <ModalOverlay />
        <ModalContent className="stak_madal_as">
          <ModalCloseButton className="close_btn_stak box_shadov_none_btn">
            <CloseIcon />
          </ModalCloseButton>
          <Box className="stak_madal_as_inn">
            <Staking />
          </Box>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={open && type == ModalType.STAKE}
        onClose={() => {
          dispatch(setOnsenModalOpen(false))
          handleDismiss
        }}
      >
        <ModalOverlay />
        <ModalContent className="stak_madal_as">
          <ModalCloseButton className="close_btn_stak box_shadov_none_btn">
            <CloseIcon />
          </ModalCloseButton>
          <Box className="stak_madal_as_inn">
            <Staking />
          </Box>
        </ModalContent>
      </Modal>

      <TokenDetail
        selectedToken={selectedItem}
        isOpen={open && type == ModalType.DETAIL}
        onClose={() => {
          dispatch(setOnsenModalOpen(false))
          handleDismiss
        }}
        onOpenPool={onAnltcsovOpen}
        isCloseButton={false}
      />
    </>
  ) : (
    <div className="w-full py-6 text-center">{term ? <span>No Results.</span> : <Dots>Loading</Dots>}</div>
  )
}

export default TokenList
